import React, { useState, forwardRef } from 'react';
import { DatePicker as AntdDatePicker, DatePickerProps, TimeRangePickerProps } from 'antd';
import classNames from 'classnames';

import './style.scss';

const PREFIX = 'music';
const BASE_CLS = PREFIX + '-date-picker';

const { RangePicker } = AntdDatePicker;

interface MusicDatePickerProps extends DatePickerProps {
  boxShadow?: boolean;
}

const DatePicker = forwardRef<any, MusicDatePickerProps>((props, ref) => {
  const { boxShadow, className, disabled, popupClassName, onOpenChange, ...otherProps } = props;
  const [planeShow, setPlaneShow] = useState(false);

  function handlePlaneChange(v: boolean) {
    setPlaneShow(v);
    onOpenChange && onOpenChange(v);
  }

  return (
    <AntdDatePicker
      disabled={disabled}
      onOpenChange={handlePlaneChange}
      popupClassName={classNames(BASE_CLS + '-popup', popupClassName)}
      className={classNames(BASE_CLS, className, {
        active: planeShow,
        shadow: boxShadow,
      })}
      ref={ref}
      {...otherProps}
    />
  );
});

interface MusicRangePickerProps extends TimeRangePickerProps {
  boxShadow?: boolean;
}

// @ts-ignore
DatePicker.RangePicker = forwardRef<any, MusicRangePickerProps>((props, ref) => {
  const { boxShadow, className, disabled, popupClassName, onOpenChange, ...otherProps } = props;
  const [planeShow, setPlaneShow] = useState(false);

  function handlePlaneChange(v: boolean) {
    setPlaneShow(v);
    onOpenChange && onOpenChange(v);
  }

  return (
    <RangePicker
      disabled={disabled}
      onOpenChange={handlePlaneChange}
      popupClassName={classNames(BASE_CLS + '-popup', popupClassName)}
      className={classNames(BASE_CLS, className, {
        active: planeShow,
        shadow: boxShadow,
      })}
      ref={ref}
      {...otherProps}
    />
  );
});

export default DatePicker;
